import _map from 'lodash/map';
import { UPDATE_GALLERY, APP_MOUNT } from '../actions/actionTypes';

export const initialState = {
  assets: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
  case UPDATE_GALLERY:
    return {
      assets: _map(action.assets, (item, index) => ({
        ...item,
        primaryLink: encodeURI(item.primaryLink),
        thumbnail: encodeURI(item.thumbnail),
        key: index,
      })),
    };
  case APP_MOUNT: {
    return {
      ...initialState,
    };
  }
  default:
    return state;
  }
};
